<template>
  <div :key="renderKey">
    <v-container>
      <v-row>
        <v-col
          v-for="(base, baseIndex) in dashboardData()"
          :key="baseIndex"
          xl="4"
          lg="4"
          md="6"
          sm="12"
          cols="12"
        >
          <v-card light min-height="150px">
            <v-card-title class="text-left">
              <v-icon :color="base.color">{{ base.icon }}</v-icon>
              <span class="text-subtitle-1">{{ base.caption }}</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col v-if="!base.group" cols="12">
                    <v-card :color="base.color" min-height="80px" dark>
                      <strong class="text-h4">
                        {{ base.totalCount }}
                      </strong>
                      <br />
                      <strong class="text-h5">
                        {{
                          base.prefix +
                          formatReal(base.value.toString()) +
                          base.suffix
                        }}
                      </strong>
                    </v-card>
                  </v-col>
                  <v-col
                    v-else
                    v-for="(group, groupIndex) in base.groupData"
                    :key="groupIndex"
                    xl="6"
                    lg="6"
                    md="6"
                    sm="12"
                    cols="12"
                  >
                    <v-card :color="base.color" min-height="80px" dark>
                      <v-card-title>
                        <span class="text-caption">{{ group.caption }}</span>
                      </v-card-title>
                      <strong class="text-h4">
                        {{ group.totalCount }}
                      </strong>
                      <br />
                      <strong class="text-h5">
                        {{
                          base.prefix +
                          formatReal(group.value.toString()) +
                          base.suffix
                        }}
                      </strong>
                    </v-card>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  name: "Dashboard",
  props: [
    "transactionName",
    "screen",
    "allQueryData",
    "loadedTransaction",
    "loading",
    "method",
    "menu",
    "allActions",
    "dynamicActions",
    "queryActions",
    "queryPage",
    "queryPages",
    "querySort",
    "queryChecks",
    "renderKey",
    "generalExApplicationEx",
    "customLanguage",
    "queryUploadLog",
    "queryRichData",

    "page",
    "checks",
    "allChecked",
    "changed",
    "fileUpload",

    "showQueryFieldsEx",
  ],
  display: "Dashboard",
  data() {
    return {};
  },
  methods: {
    solveCatalogName(fieldName, record) {
      const value = record[fieldName];
      let result = value;
      this.screen.queryFieldsEx.forEach((queryFieldEx) => {
        const queryField = queryFieldEx.queryField;
        const dictionaryName = queryField.dictionaryName;
        const dictionary = this.findDictionary(this.screen, dictionaryName);

        if (this.isCatalog(dictionary)) {
          const inputData = this.basicBuildInputData(
            queryField.inputFields,
            record
          );
          const catalogEx = this.findCatalogEx(
            this.screen,
            dictionaryName,
            inputData
          );
          if (catalogEx && queryField.fieldName == fieldName) {
            if (Array.isArray(catalogEx.items)) {
              catalogEx.items.forEach((item) => {
                if (item.itemId == value) {
                  result = this.translatedConfig(
                    this.generalExApplicationEx,
                    this.customLanguage,
                    item,
                    "itemName"
                  );
                }
              });
            }
          }
        }
      });
      return result;
    },

    dashboardData() {
      let result = [];
      if (this.queryDashboardScreen(this.screen)) {
        const allFields = this.showQueryFieldsEx();
        const allData = this.allQueryData;
        allFields.forEach((qfe) => {
          const queryField = qfe.queryField;
          const dictionaryName = queryField.dictionaryName;
          const dictionary = this.findDictionary(this.screen, dictionaryName);
          const items = this.findCatalogExList(
            this.screen,
            dictionaryName,
            queryField.inputFields
          );
          //const dictionary = qfe.dictionary;
          //const items = qfe.catalogEx.items;
          const caption = this.translatedConfig(
            this.generalExApplicationEx,
            this.customLanguage,
            queryField,
            "caption"
          );

          if (queryField.totalize) {
            const totalize = queryField.totalize;
            const group = totalize.includes(":");
            const arrayGroup = group ? totalize.split(":") : [totalize, null];
            const arrayFields = group ? arrayGroup[1].split(",") : null;
            const operation = group ? arrayGroup[0] : totalize;
            const prefix =
              queryField.prefix == "$" || queryField.suffix == "$"
                ? this.glbLocationCurrency() == "before"
                  ? "$ "
                  : ""
                : queryField.prefix
                ? queryField.prefix + " "
                : "";
            const suffix =
              queryField.prefix == "$" || queryField.suffix == "$"
                ? this.glbLocationCurrency() == "after"
                  ? " $"
                  : ""
                : queryField.suffix
                ? " " + queryField.suffix
                : "";
            result.push({
              fieldName: queryField.fieldName,
              operation: operation,
              items: items,
              inputFields: queryField.inputFields,
              dictionaryName: dictionary.name,
              caption: caption,
              icon: queryField.icon,
              color: queryField.color,
              dataType: dictionary.dataType,
              group: group,
              groupFields: arrayFields,
              groupData: [],
              totalCount: 0,
              totalSum: 0,
              value: 0,
              prefix: prefix,
              suffix: suffix,
            });
          }
        });

        allData.forEach((record) => {
          result.forEach((element) => {
            let summary = element;
            const value = record[summary.fieldName];
            if (summary.group) {
              let key = "";
              let keyCaption = "";
              summary.groupFields.forEach((groupField, i) => {
                key += groupField + record[groupField];

                const auxCaption = this.solveCatalogName(
                  groupField,
                  record
                );

                keyCaption +=
                  auxCaption + (i < summary.groupFields.length - 1 ? "/" : "");
              });
              let found = null;
              summary.groupData.forEach((data, index) => {
                if (data.key == key) {
                  found = index;
                }
              });
              if (found == null) {
                summary.groupData.push({
                  key: key,
                  caption: keyCaption,
                  totalCount: 0,
                  totalSum: 0,
                  value: 0,
                });
                found = summary.groupData.length - 1;
              }
              summary.groupData[found].totalCount++;
              summary.groupData[found].totalSum += value;
              switch (summary.operation) {
                case "count": {
                  summary.groupData[found].value++;
                  break;
                }
                case "sum": {
                  summary.groupData[found].value += value;
                  break;
                }
                case "average": {
                  summary.groupData[found].value =
                    summary.groupData[found].totalSum /
                    summary.groupData[found].totalCount;
                }
              }
            } else {
              summary.totalCount++;
              summary.totalSum += value;
              switch (summary.operation) {
                case "count": {
                  summary.value++;
                  break;
                }
                case "sum": {
                  summary.value += value;
                  break;
                }
                case "average": {
                  summary.value = summary.totalSum / summary.totalCount;
                }
              }
            }
          });
        });
      }
      return result;
    },
  },
  updated() {},
};
</script>

<style scoped>
</style>
